import { render, staticRenderFns } from "./KitItemsManager.vue?vue&type=template&id=210b4ef5&scoped=true"
import script from "./KitItemsManager.vue?vue&type=script&lang=js"
export * from "./KitItemsManager.vue?vue&type=script&lang=js"
import style0 from "./KitItemsManager.vue?vue&type=style&index=0&id=210b4ef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b4ef5",
  null
  
)

export default component.exports